import { Typography } from '@mui/material';
import styled from '@emotion/styled';
import { borderRadius, color, spacing } from '@/theme/tokens';
import Link from 'next/link';

const StyledSidebarLink = styled(Link, {
    shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive?: boolean }>`
    text-decoration: none;
    width: 100%;
    display: block;
    padding: 0 ${spacing[12]};
    background-color: ${props => (props.isActive ? color.white[0] : 'transparent')};
    border-radius: ${borderRadius[8]};
    height: 46px;
    display: flex;
    align-items: center;

    &:hover {
        background-color: ${props => (props.isActive ? color.white[0] : color.white[30])};
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid ${color.gray[80]};
        outline-offset: 2px;
    }
`;

interface SidebarStyledLinkProps {
    href: string;
    isActive?: boolean;
    children: React.ReactNode;
}

export default function SidebarStyledLink({ href, isActive, children }: SidebarStyledLinkProps) {
    return (
        <StyledSidebarLink href={href} isActive={isActive}>
            <Typography variant="label5medium" color={color.gray[80]} width="100%">
                {children}
            </Typography>
        </StyledSidebarLink>
    );
}
